export const getPdfPreviewUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  if (url.startsWith("data:")) return url;
  if (url.includes("NoSuchKey") || url.includes("<Error>")) return "";

  try {
    const parsed = new URL(url);
    // Avoid mixed-content blocking: upgrade http -> https when the app itself
    // is served over https (otherwise the PDF iframe renders blank).
    if (
      parsed.protocol === "http:" &&
      typeof window !== "undefined" &&
      window.location?.protocol === "https:"
    ) {
      parsed.protocol = "https:";
    }
    parsed.pathname = parsed.pathname
      .split("/")
      .map((segment) => encodeURIComponent(decodeURIComponent(segment)))
      .join("/");
    return parsed.toString();
  } catch {
    return encodeURI(url);
  }
};
